
import "./CreateClient.css";
import React, { useEffect } from "react";
import { useGlobalContext } from "../../context";
import { radioType } from "../../interfaces";

type propsType = {
    activeNoun: string,
    setActiveNoun: (activeNoun: string) => void,
}

function WichNounForm({ setActiveNoun }: propsType) {

    const { whichNounForm, setWichNounForm } = useGlobalContext();

    const handleChange = (elem: radioType): void => {
        setWichNounForm((whichNounForm: radioType[]) => whichNounForm.map((item: radioType) => item.id === elem.id ? { ...item, active: true } : { ...item, active: false }));
    }

    useEffect(() => {
        const activeObj: radioType | undefined = whichNounForm.find((item: radioType) => item.active);
        if (activeObj) {
            setActiveNoun(activeObj.title);
        }
    }, [whichNounForm]);

    return(
        <div className="WichNounForm">
            <div className="form-emailAddress-box">
                <label className="required"> Which noun form? </label>
            </div>
            {
                whichNounForm.map((item: radioType) => {
                    return <div className="form-package-box" key = { item.id } onClick = {() => handleChange(item)}>
                        <input
                            className = "packageOption"
                            type = "radio"
                            checked = { item.active }
                            name = {"Noun"}
                        />
                        <label>{ item.title }</label>
                    </div>
                })
            }
        </div>
    )
}

export default WichNounForm;